import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ActionBar, ButtonVariant, Heading } from '@dreryk/react-components';

import { MedicalCertificateForm } from './form/MedicalCertificateForm';
import { VisitMedicalCertificateApproveAndPrintAction } from './form/MedicalCertificateForm.actions';
import { MedicalCertificateFormLeavingGuard } from './form/MedicalCertificateForm.guard';
import { MedicalCertificateFormLoader } from './form/MedicalCertificateForm.loader';
import { medicalCertificateTranslationKeys } from './translations';

type MedicalCertificatePanelProps = {
   readonly visitId: number;
   readonly dictionaryValidOn: Date;
   readonly diagnosisSuggestions: VisitDiagnosis[];
};

export const MedicalCertificatePanel = (props: MedicalCertificatePanelProps): JSX.Element => {
   return (
      <div>
         <Heading type={'h1'} testId={'medicalCertificate'} content={medicalCertificateTranslationKeys.panel.title} />
         <MedicalCertificateFormLoader visitId={props.visitId}>
            {({ medicalCertificateDraft }) => (
               <MedicalCertificateForm
                  medicalCertificateDraft={medicalCertificateDraft}
                  dictionaryValidOn={props.dictionaryValidOn}
                  visitDiagnoses={props.diagnosisSuggestions}
               >
                  {({ handleSubmit, handleSubmitDraft, markPristine, formState }) => (
                     <>
                        <MedicalCertificateFormLeavingGuard
                           visitId={props.visitId}
                           handleSubmitDraft={handleSubmitDraft}
                           formState={formState}
                        />
                        <VisitMedicalCertificateApproveAndPrintAction visitId={props.visitId} onSuccess={markPristine}>
                           {({ approveAndPrint }) => (
                              <ActionBar.PrimaryButton
                                 testId={'approveAndPrint'}
                                 variant={ButtonVariant.PRIMARY}
                                 onClick={handleSubmit(approveAndPrint)}
                                 label={medicalCertificateTranslationKeys.panel.actions.approveAndPrint.label}
                                 blockingOperation
                              />
                           )}
                        </VisitMedicalCertificateApproveAndPrintAction>
                     </>
                  )}
               </MedicalCertificateForm>
            )}
         </MedicalCertificateFormLoader>
      </div>
   );
};
